import React from "react";
import { Card, CardBody } from "reactstrap";

const VendorAccountCard = ({ vendorDetails }) => (
  <Card className="mb-3">
    <CardBody>
      <div className="text-bold mb-3" style={{ fontSize: 18 }}>
        Vendor payment account
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "15px",
          fontSize: "14px",
        }}
      >
        <div>
          <span style={{ color: "#757575" }}>Preferred Payment Method:</span>
          <br />
          <span className="text-bold">
            {vendorDetails?.preferredPaymentMethod || "-"}
          </span>
        </div>
        <div>
          <span style={{ color: "#757575" }}>Bank Code:</span>
          <br />
          <span className="text-bold">{vendorDetails?.bankName || "-"}</span>
        </div>
        <div>
          <span style={{ color: "#757575" }}>Bank Branch:</span>
          <br />
          <span className="text-bold">{vendorDetails?.bankBranch || "-"}</span>
        </div>
        <div>
          <span style={{ color: "#757575" }}>Account Holder Name:</span>
          <br />
          <span className="text-bold">
            {vendorDetails?.accountHolderName || "-"}
          </span>
        </div>
        <div>
          <span style={{ color: "#757575" }}>Account Number:</span>
          <br />
          <span className="text-bold">{vendorDetails?.bankAccount || "-"}</span>
        </div>
        <div>
          <span style={{ color: "#757575" }}>IFSC Code:</span>
          <br />
          <span className="text-bold">{vendorDetails?.ifsc || "-"}</span>
        </div>
        <div>
          <span style={{ color: "#757575" }}>Account Type:</span>
          <br />
          <span className="text-bold">{vendorDetails?.accountType || "-"}</span>
        </div>
      </div>
    </CardBody>
  </Card>
);

export default VendorAccountCard;
